<template>
    <div class="reservation-component text-none pa-0 pa-md-6 pb-0 mb-6 mb-md-0" v-if="reservation">
        <div class="number-wrapper text-left d-flex flex-column">
            <div class="text-left d-flex flex-md-row flex-column align-md-center align-left justify-space-between">
                <span class="d-flex align-md-center align-start align-top mb-2 mb-md-0">
                    <img :src="box_icon" class="mr-3 mb-0 mb-md-1 mt-1 mb-md-0" />
                    <span>Rezerwacja <b class="mx-2">{{ reservation.reservation_id }}</b> /
                    Zamówienie <b class="mx-2">{{ reservation.order_id }}</b></span>
                </span>

                <div class="date-wrapper text-right">
                    <div class="status-wrapper ml-md-0 ml-8 mb-md-0 mb-2">
                        <div class="label d-flex flex-row align-center">
                            Status
                            <div :class="['status px-3 ml-2', reservation.status]">{{this.$t(`status.${reservation.status}`)}}</div>
                        </div>
                    </div>
                </div>

                <div class="date-wrapper text-left d-flex align-center">
                    <img :src="calendar_icon" class="mr-3" />Data rezerwacji {{ this.$d(reservation.reservation_time, 'short') }}
                </div>
            </div>
            <div v-if="reservation.status == 'CREATED'" class="d-flex flex-md-row flex-column align-md-center align-left justify-end">
                <div class="status-wrapper ml-5 mr-16 mt-2">
                    <div class="label d-flex flex-row align-center">
                        <div class="timer ml-2">
                            <timer-component
                                ref="timer"
                                :date="reservation.expiration_time || ''"
                                :on="reservation.status == 'CREATED'"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <v-divider class="my-7"></v-divider>
        </div>

        <div class="data-row d-flex flex-md-row flex-column">
            <div class="package-name-wrapper mb-6 mb-md-0 pl-8 w-100">
                <div class="package-name-data text-left mb-4">
                    <span class="product-name">{{ getName() }}</span> ({{ reservation.reservation_data.product_key }})
                </div>
                <div class="text-left label">
                    Ilość
                    <span class="reservation-data ml-2">
                        {{ reservation.reservation_data.quantity }}
                    </span>
                </div>
                <div class="text-left label" v-if="reservation.transport_data?.type !== 'INTERNAL'">
                    Cena
                    <span class="reservation-data ml-2">
                        {{ getUnitPrice() }} za pakiet
                    </span>
                </div>
                <div class="text-left label" v-if="reservation.transport_data?.type !== 'INTERNAL'">
                    Pakiet refundowany
                    <span class="reservation-data ml-2 d-inline-block">
                        <span class="d-flex flex-row">{{ reservation.reservation_data?.mz_grant_file_id > 0 ? "Tak" : "Nie" }}
                        <img :src="paid_icon" v-if="reservation.reservation_data?.mz_grant_file_id > 0" class="ml-2"></span>
                    </span>
                </div>
                <div class="text-left label" v-if="reservation.transport_data?.type !== 'INTERNAL'">
                    Razem
                    <span class="reservation-data ml-2 d-inline-block">
                        <span :class="[reservation.reservation_data?.mz_grant_file_id > 0 ? 'no-refund' : '']">
                            {{ getValue(false) }}
                        </span>
                        <span v-if="reservation.reservation_data?.mz_grant_file_id > 0" class="ml-2">
                            {{ getValue(true) }}
                        </span>
                    </span>
                </div>
                <div class="text-left label">
                    Dawca
                    <span class="reservation-data ml-2">
                        {{ reservation.reservation_data.donor_id }}
                    </span>
                </div>
                <div class="text-left label">
                    Nick
                    <span class="reservation-data ml-2">
                        {{ reservation.reservation_data.donor_nickname ?? '' }}
                    </span>
                </div>
                <div class="text-left label" data-test="donor-age">
                    Wiek
                    <span class="reservation-data ml-2" data-test="donor-age-value">
                        {{ reservation.reservation_data.age ?? '-' }}
                    </span>
                </div>
                <div class="text-left label" v-if="reservation.transport_data?.type !== 'INTERNAL'">
                    Fenotyp dawcy
                    <span class="reservation-data ml-2">
                        <span :class="['phenotype-type', donor_accepted ? 'accepted' : '']">
                        {{ donor_accepted ? 'Zaakceptowany' : 'Zmigrowany' }}
                        </span>
                    </span>
                </div>
                <div class="text-left label">
                    Lokalizacja
                    <span class="reservation-data ml-2">
                        {{ reservation.reservation_data.material_location_name ?? '' }}
                    </span>
                </div>
                <div class="text-left label">
                    Miejsce leczenia
                    <span class="reservation-data ml-2">
                        {{ reservation.reservation_data.location_of_treatment_name ?? '' }}
                    </span>
                </div>
                <div v-if="reservation.transport_data && Object.keys(reservation.transport_data).length">
                    <v-divider class="my-4"></v-divider>
                    <div class="package-name-data text-left d-flex align-center mb-2">
                        <img :src="truck_icon" class="mr-2" />
                        <span v-if="reservation.transport_data?.type == 'INTERNAL'">
                            Transport wewnętrzny
                        </span>
                        <span v-else>
                            Transport
                        </span>
                    </div>
                    <div class="text-left label mt-1">
                    Status transportu
                        <div :class="['status px-3 py-0 ml-2', reservation.transport_data?.status_code]">
                            {{reservation.transport_data?.status_code ? this.$t(`status.${reservation.transport_data.status_code}_transport`) : null}}
                        </div>
                    </div>
                    <div class="text-left label mt-1">
                        Kierunek
                        <span class="recipient-data ml-2">
                            {{ $t(reservation.transport_data.material_localization_name) }}<img :src="shevronIcon" height="8" class="mx-2"/>{{ $t(reservation.transport_data.treatment_localization_name) }}
                        </span>
                    </div>
                    <div class="text-left label mt-2" v-if="reservation.transport_data?.type !== 'INTERNAL'">
                        Cena
                        <span class="reservation-data ml-2">
                            {{ this.$n(reservation.transport_data.price, 'currency', 'pl') }}
                        </span>
                    </div>
                </div>
            </div>

            <v-spacer v-if="!$vuetify.display.mobile"></v-spacer>
            <div v-if="reservation.transport_data?.type !== 'INTERNAL'" class="recipient-data-wrapper ml-md-4 ml-0 mb-6 mb-md-0 pa-4 w-100">
                <div class="package-name-data text-left d-flex align-center">
                    <img :src="person_icon" class="mr-2" /> Biorca
                </div>
                <div class="text-left label">
                    Biorca
                    <span class="recipient-data ml-2">
                        {{ reservation.user_data?.first_name }} {{ reservation.user_data?.last_name }} 
                        ({{ reservation.user_data?.birth_date }})
                    </span>
                </div>
                <div class="text-left label">
                    PESEL
                    <span class="recipient-data ml-2">
                        {{ reservation.user_data?.pesel_number }}
                    </span>
                </div>
                <div class="text-left label">
                    E-mail
                    <span class="recipient-data ml-2">
                        {{ reservation.user_email }}
                    </span>
                </div>
                <!-- <div class="text-left label">
                    ID
                    <span class="recipient-data ml-2">
                        {{ reservation.reservation_data.profile_public_id }}
                    </span>
                </div> -->
            </div>
            <v-spacer v-if="!$vuetify.display.mobile"></v-spacer>
        </div>

        <div class="bottom-bar">
            <v-divider v-if="!$vuetify.display.mobile" class="my-6"></v-divider>
            <div v-if="reservation.transport_data?.type !== 'INTERNAL'"
                class="pl-0 pl-md-4 d-flex flex-md-row flex-column align-md-center align-start">
                <div class="text-left mb-md-0 mb-4 w-auto panel" v-if="reservation.reservation_data.product_key && oidcUser">
                    <!-- <div :class="['phenotype-type', donor_accepted ? 'accepted' : '']">
                        {{ donor_accepted ? 'Zaakceptowany' : 'Zmigrowany' }}
                    </div> -->
                    <compare-to-donor-component 
                        :donor_phenotype="{
                            age: reservation.reservation_data.age,
                        }"
                        :donor_id="reservation.reservation_data.donor_id"
                        :donor_nickname="reservation.reservation_data.donor_nickname ?? ''"
                        :donor_product_key="reservation.reservation_data.product_key"
                        :donor_material_type="reservation.reservation_data.material_type"
                        :user_id="reservation.user_id"
                        :oidc_user="oidcUser"
                        :reservation_id="reservation.reservation_id"
                        :key="reservation.reservation_id"
                        :type="'reservation'"
                        @compare-dialog="hasOpenCompareDialog">
                    </compare-to-donor-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from 'vuex';
import axios from "axios";
import TimerComponent from "../TimerComponent.vue";
import CompareToDonorComponent from '../CompareToDonorComponent.vue';

export default {
    name: "booking-component",
    data: () => {
        return {
            compareDialog: false,
            donor_accepted: null
        }
    },
    props: {
        reservation: {
            type: Object
        }
    },
    components: {
        TimerComponent,
        CompareToDonorComponent
    },
    emits: ['compare-dialog'],
    watch: {
        compareDialog(d) {
            this.$emit('compare-dialog', d)
        }
    },
    setup() {
        const store = useStore()
        const box_icon = computed({
            get: () => { return require('@/assets/icons/box.svg'); }
        })
        const calendar_icon = computed({
            get: () => { return require('@/assets/icons/calendar.svg'); }
        })
        const paid_icon = computed({
            get: () => { return require('@/assets/icons/paid.svg');}
        })
        const truck_icon = computed({
            get: () => { return require('@/assets/icons/truck.svg'); }
        })
        const person_icon = computed({
            get: () => { return require('@/assets/icons/person.svg');}
        })
        const shevronIcon = computed({
            get: () => { return require('@/assets/icons/chevron-right.svg'); }
        })
        return {
            box_icon,
            calendar_icon,
            paid_icon,
            truck_icon,
            person_icon,
            shevronIcon,
            oidcUser: computed(() => store.getters['oidcStore/oidcUser'])
        }
    },
    mounted() {
        this.getAccepted();
    },
    methods: {
        hasOpenCompareDialog(d) {
            this.compareDialog = d
        },
        getName() {
            return this.reservation.reservation_data.product_name;
        },
        getValue(discount) {
            /*
            if (this.reservation.reservation_data.total_price)
                return this.$n(
                    discount
                    ? (this.reservation.reservation_data.quantity - 1) * this.reservation.reservation_data.price
                    : this.reservation.reservation_data.total_price,
                    'currency',
                    'pl'
                );
            else
                return this.$n(0, 'currency', 'pl');
            */
            return this.$n(
                discount
                ? 0
                : this.reservation.reservation_data.quantity * this.reservation.reservation_data.price,
                'currency',
                'pl'
            );
        },
        getUnitPrice() {
            if(this.reservation.reservation_data.price)
                return this.$n(this.reservation.reservation_data.price, 'currency', 'pl');
            else
                return 0;
        },
        getAccepted() {
            axios.get(`/api/phenotype/reservation/${this.reservation.reservation_id}`)
            .then((response) => {
                this.donor_accepted = response.data.partner?.accepted && response.data.own?.accepted;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.phenotype-type {
    // position: absolute;
    // top: -16px;
    // right: -16px;
    border-radius: 16px;
    // border: 1px solid gray;
    padding: 2px 8px;
    // color: var(--nsb-color-1, #0E346F);
    // background: rgb(228, 166, 166);
    color: var(--Text-status-error, #D6001C);
    background: var(--Background-status-danger, #FFEBEB);
    // box-shadow: 0px 2px 4px rgba(0,0,0,0.4);
    &.accepted {
        // color: var(--nsb-color-1, #0E346F);
        // background: rgb(202, 236, 202);
        color: #097122;
        background: var(--Background-status-success, #EBFFEF);
    }
}

.v-divider {
  border-color: var(--borders-dividers-default, #E2E6EE) !important;
}

.reservation-component {
    box-sizing: border-box;
    background: white;

    @include nsb-font-container;
    font-size: 14px;
    line-height: 21px;

    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: repeat(3, auto);
    grid-column-gap: 0px;
    grid-row-gap: 0px;

    .number-wrapper {
        grid-area: 1 / 1 / 2 / 2;
        font-size: 16px;
        line-height: 24px;
    }

    .date-wrapper {
        grid-area: 1 / 2 / 2 / 3;
        font-size: 16px;
        line-height: 24px;
    }

    .data-row {
        grid-area: 2 / 1 / 3 / 3;
    }

    .bottom-row {
        grid-area: 3 / 1 / 4 / 3;
    }

    .bottom-bar { 
        grid-area: 4 / 1 / 5 / 4;
    }

    .package-name-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .label {
        @include nsb-select-placeholder;
        font-size: 14px;
        line-height: 22px;
        color: $ds-primary-100;
        display: grid;
        grid-template-columns: 140px auto;
        span {
            font-size: 14px;
            line-height: 22px;
        }
    }

    .package-name-data {
        @include nsb-font-container;
        font-size: 16px;
        line-height: 24px;
        .product-name {
            @include nsb-font-header-bold;
            font-size: 16px;
            line-height: 24px;
        }
    }

    .reservation-data, .recipient-data {
        @include nsb-font-container;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }

    .status {
        @include nsb-font-container;
        color: $ds-primary;
        border-radius: 12px;
        font-size: 12px;
        display: inline-block;
        width: max-content;
        &.CANCELED {
            // background: $sd-error-2;
            background: var(--Background-status-danger, #FFEBEB);
            color: var(--Text-status-error, #D6001C);
        }
        &.CANCELED_BY_USER {
            // background: $sd-error-2;
            background: var(--Background-status-danger, #FFEBEB);
            color: var(--Text-status-error, #D6001C);
        }
        &.CREATED {
            background: $ds-primary-8; 
        }
        &.ERROR {
            // background: $sd-error-2;
            background: var(--Background-status-danger, #FFEBEB);
            color: var(--Text-status-error, #D6001C);
        }
        &.FINISHED {
            // background: $ds-success-2;
            background: var(--Background-status-success, #EBFFEF);
            color: #097122;
        }
        &.PROCESSED {
            background: $ds-secondary-4; 
        }
        &.PAYMENT_IN_PROGRESS {
            background: $ds-primary-8;
        }
        &.IN_PROGRESS {
            background: $ds-primary-8;
        }
        &.PLANNED {
            background: $ds-primary-8;
        }
        &.PAID {
            background: $ds-primary-8;
        }
    }
    .recipient-data-wrapper {
        // border: 1px solid $ds-background;
        border: 1px solid var(--borders-dividers-default, #E2E6EE);
        border-radius: 4px;
        height: max-content;
        display: flex;
        flex-direction: column;
        gap: 8px;
        .label {
            grid-template-columns: 100px auto;
        }
    }

    .panel {
        position: relative;
        border-radius: 12px;
        border: 1px solid transparent !important;
        cursor: pointer;
    }
    .panel:hover {
        border: 1px solid var(--nsb-color-1, #0E346F) !important;
    }
    .no-refund {
        line-height: normal;
        color: $ds-primary-100;
        text-decoration: line-through;
    }
}

@media (max-width: 960px) {
    .reservation-component {
        // border-bottom: 1px solid $nsb-color-3;
        border-bottom: 1px solid var(--borders-dividers-default, #E2E6EE);
    }

    .bottom-bar { 
        grid-area: 3 / 1 / 4 / 5;
    }
}
</style>